import { Widget } from '@framework/engine';
import { WidgetColumn, WidgetRow } from '@framework/engine-ui';
import React from 'react';
import { FillableWidget } from './FillableWidget';

export interface IFillableWidgetListProps {
  widgets: Widget[];
  parent?: Widget;
  readonly?: boolean;
  /** Permette di gestire dinamicamente il readonly per ogni singolo widget */
  isReadonly?: (widget: Widget) => boolean;
}

/**
 * Lista di tutti i componenti widget di un form
 */
export function FillableWidgetList(props: IFillableWidgetListProps) {
  const { widgets, parent, readonly } = props;

  return (
    <WidgetRow gutter={[24, 0]}>
      {widgets.map(widget => (
        <WidgetColumn parent={parent} widget={widget} key={widget.id}>
          <FillableWidget
            widget={widget}
            parent={parent}
            readonly={readonly}
            isReadonly={props.isReadonly}
          />
        </WidgetColumn>
      ))}
    </WidgetRow>
  );
}
